/*
 * @Description: 退单信息提交
 * @Author: 杨志航
 * @Date: 2026-05-09 17:49:22
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  InputNumber,
  message,
  DatePicker,
  Upload,
  Icon,
  Select,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { uploadDragger } from '@/utils/uploadDragger'
import { allTrim } from '@/utils'

const FormItem = Form.Item
const Option = Select.Option
const { Dragger } = Upload
const dateFormat = 'YYYY-MM-DD'
const typeList = [
  { id: 0, name: '直销订单'},
  { id: 1, name: '代理商订单'},
]
let draggerObj = {}

const SubmitInfo = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { setInfoVisible, infoData, history } = props
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    draggerObj = uploadDragger({
      accept: '.jpg, .jpeg, .png, .pdf',
      limitNum: 5,
      limitSize: 10,
    })
    const { vendor, currentUserNumber, type } = infoData
    if (vendor) {
      setFieldsValue({
        vendor,
      })
    }
    if (currentUserNumber) {
      setFieldsValue({
        applyUserNumber: currentUserNumber,
      })
    }
    setFieldsValue({
      type,
    })
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals.exitDate = vals.exitDate.format(dateFormat)
        vals.quickRefundAppendix = vals.quickRefundAppendix.map(item => {
          const { name, url } = item
          return {
            name,
            url,
          }
        })
        const params = {
          type: vals.type,
          vendor: vals.vendor,
          applyUserNumber: vals.applyUserNumber,
          chargebackmoney: vals.chargebackmoney,
          isQuick: 1,
        }
        setSaveLoading(true)
        api.getFortuneOrderRefundList(params).then(res => {
          setSaveLoading(false)
          const { list } = res
          let hasAuditOrder = false
          const avaList = []
          //当系统实退金额为数字且大于0的时候可以进行退单
          //但是如果存在审批中、驳回中的的订单 不可以退单
          //如果存在可消耗余额不足的订单，只能退有可消耗的订单
          list.forEach(item => {
            if(typeof +item.backMoney === 'number' && !isNaN(+item.backMoney)){
              if(+item.backMoney > 0) avaList.push(item)
            }else{
              if((item.backMoney + '').indexOf('正在审批') > -1){
                hasAuditOrder = true
              }
            }
          })
          const srList = avaList.reduce((prev, curr) => {
            let json = {}
            if(res.backids && res.backids.includes(curr.id)){
              json[curr.id] = curr.backMoney
            }
            return [...prev, json]
          }, [])
          const systemRefund = srList.filter(item => JSON.stringify(item) !== '{}')

          const ckpList = avaList.map(item => {
            if(res.backids && res.backids.includes(item.id)){
              return item.colmarketprice
            }
          })
          const colmarketprice = ckpList.filter(item => item)

          const cmpList = avaList.map(item => {
            if(res.backids && res.backids.includes(item.id)){
              return item.chargebackMarketprice
            }
          })
          const chargebackMarketPrice = cmpList.filter(item => item)

          let backList = []
          if(res.backids){
            backList = avaList.filter(item => res.backids.includes(item.id))
          }

          if (hasAuditOrder) {
            return message.warning('抱歉，该客户退单申请正在审批中，请检查审批中订单模块，是否有“审批中”或“被驳回”的退单！')
          }
          if (backList.length === 0) {
            return message.warning('当前厂商系统实退金额下没有订单可退')
          }
          setInfoVisible(false)
          history.push('/orderManage/quickRefund/refundapply', { 
            backList, //可退订单列表
            systemRefund, //系统实退金额
            chargebackMarketPrice, //可退市场价
            colmarketprice, //市场价
            isQuick: 1, //是否快捷退单
            ...vals,
          })
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="厂商ID">
          {getFieldDecorator('vendor', {
            rules: [{ required: true, message: '请输入厂商ID' }]
          })(
            <Input placeholder="请输入厂商ID" />
          )}
        </FormItem>
        <FormItem label="订单负责人员工编号">
          {getFieldDecorator('applyUserNumber', {
            rules: [{ required: true, message: '请输入员工编号' }]
          })(
            <Input placeholder="请输入员工编号" />
          )}
        </FormItem>
        <FormItem label="类型">
          {getFieldDecorator('type', {
            initialValue: 0,
            rules: [{ required: true, message: '请选择类型' }]
          })(<Select placeholder="请选择">
            {
              typeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
            }
          </Select>)}
        </FormItem>
        <FormItem label="退单市场价">
          {getFieldDecorator('chargebackmoney', {
            rules: [{ required: true, message: '请输入退单市场价' }]
          })(
            <InputNumber 
              placeholder="请输入退单市场价" 
              style={{ width: '100%'}}
              min={0}
              precision={2}
            />
          )}
        </FormItem>
        <FormItem label="系统撤资日期">
          {getFieldDecorator('exitDate', {
            rules: [{ required: true, message: '请选择系统撤资日期' }]
          })(
            <DatePicker 
              placeholder="请选择" 
              format={dateFormat}
              style={{ width: '100%'}}
            />
          )}
        </FormItem>
        <Form.Item label="上传附件">
          {getFieldDecorator('quickRefundAppendix', {
            valuePropName: 'fileList',
            getValueFromEvent: draggerObj.normFile,
            rules: [{ required: true, message: '请上传附件' }]
          })(
            <Dragger {...draggerObj}>
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
              <p className="ant-upload-hint">
                支持扩展名：.jpg、.jpeg、.png、.pdf<br/>单个文件大小不超过10M，不超过5个附件。
              </p>
            </Dragger>
          )}
        </Form.Item>
        <Form.Item label="备注">
          {getFieldDecorator('quickRefundRemark')(
            <Input.TextArea placeholder="请输入备注" rows={6} maxLength={500}/>
          )}
        </Form.Item>
        <BtnGroup onCancel={() => setInfoVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(SubmitInfo)
